import SpreadsheetDropzone from './SpreadsheetDropzone.component';

export default SpreadsheetDropzone;
